import '@/fonts.css';
import { createTheme, Notification, rem } from '@mantine/core';

export const DEFAULT_THEME = createTheme({
  fontFamily: 'NunitoSans, sans-serif',

  fontSizes: {
    32: rem(32),
    28: rem(28),
    23: rem(23),
    19: rem(19),
    16: rem(16),
    14: rem(14),
    13: rem(13),
    11: rem(11)
  },
  spacing: {
    8: rem(8),
    16: rem(16),
    24: rem(24),
    32: rem(32),
    48: rem(48),
    56: rem(56)
  },
  colors: {
    'primary-club': [
      '#C6DCF7',
      '#cfe6ff',
      '#a0cafb',
      '#6eacf5',
      '#4493f1',
      '#2883ef',
      '#147bef',
      '#0069d5',
      '#005dc0',
      '#0050aa'
    ]
  },
  primaryColor: 'dark',
  headings: {
    fontFamily: 'Unbounded, sans-serif',
    sizes: {
      h1: {
        fontSize: rem(28),
        fontWeight: '700',
        lineHeight: '1'
      },
      h2: {
        fontSize: rem(23),
        fontWeight: '600',
        lineHeight: '1'
      },
      h3: {
        fontSize: rem(19),
        fontWeight: '500',
        lineHeight: '1.2'
      },
      h4: {
        fontSize: rem(14),
        fontWeight: '500',
        lineHeight: '1.2'
      }
    }
  },
  components: {
    Notification: Notification.extend({
      styles: {
        root: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'start',
          boxShadow: `var(--mantine-shadow-light)`,
          backgroundColor: `var(--base-dark-2)`,
          borderRadius: `var(--mantine-radius-8)`
        },
        title: {
          color: 'white'
        },
        description: {
          color: 'white'
        },
        icon: {
          backgroundColor: 'transparent'
        },
        closeButton: {
          backgroundColor: 'transparent',
          color: 'white',
          '&:hover': {
            opacity: 0.8,
            backgroundColor: 'transparent'
          }
        }
      }
    })
  },
  radius: {
    2: rem(2),
    8: rem(8),
    12: rem(12),
    16: rem(16)
  },
  lineHeights: {
    100: '1',
    120: '1.2',
    140: '1.4',
    150: '1.5'
  },
  shadows: {
    heavy: '0px 0px 20px 5px rgba(0, 0, 0, 0.08)',
    medium: '0px 4px 20px 0px rgba(0, 0, 0, 0.08)',
    light: '0px 0px 30px 0px rgba(0, 0, 0, 0.05)'
  },
  other: {
    colors: {
      club: {
        primary: '#2E86EF',
        secondary: '#82B6F5'
      },
      artist: {
        primary: '#F74360',
        secondary: '#FA8EA0'
      },
      base: {
        dark: {
          main: '#1D1F22',
          1: '#3A3C3F',
          2: '#4F5053',
          3: '#5F6163'
        },
        gray: {
          main: '#72757E',
          1: '#92949F'
        },
        light: {
          main: '#F1F2F3',
          white: '#FFFFFF'
        },
        background: '#F1F2F3'
      },
      context: {
        info: {
          main: '#449BFF',
          1: '#B4D2F4'
        },
        succes: {
          main: '#5ECE7B',
          1: '#9EE2B0'
        },
        danger: {
          main: '#FF3131',
          1: '#FFDAD8'
        }
      }
    }
  }
});
